export default __webpack_public_path__ + "d3e83dcab6580d79c081c6a21361a873.svg";